var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"footer"}},[_vm._v("© "+_vm._s(_vm.year)+" "+_vm._s(_vm.$t('layout.mcdonalds'))+" "),_c('a',{attrs:{"href":_vm.template_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('layout.privacy_policy')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }